<div serigyItem="acessibilidadeCaminhoPaginas">
  <div vw class="enabled">
    <div vw-access-button class="active"></div>
    <div vw-plugin-wrapper>
      <div class="vw-plugin-top-wrapper"></div>
    </div>
  </div>

  <div class="accessibility-container" serigySchema="https://serigy.tce.se.gov.br/comum/acessibilidade.html">
    <div #accessibilityIcon class="accessibility-icon" (click)="toggleAccessibility()">
      <img src="assets/images/icon-acessibilidade-2025.png" class="icon-acessibilidade-2025"
        alt="Ícone de Acessibilidade" serigyItem="acessibilidadeSimbolo">
    </div>

    <div #accessibilityMenu class="accessibility-menu">
      <button id="font-increase" class="accessibility-button" title="Aumentar Fonte" (click)="aumentarTexto()"
        matTooltip="Aumentar Fonte" serigyItem="acessibilidadeRedimensionamentoTexto">A+</button>
      <button id="font-decrease" class="accessibility-button" title="Diminuir Fonte" (click)="diminuirTexto()"
        matTooltip="Diminuir Fonte" serigyItem="acessibilidadeRedimensionamentoTexto">A-</button>
      <button id="restore-default" class="accessibility-button text-nowrap" title="Restaurar Fonte"
        (click)="restaurarPadrao()" matTooltip="Restaurar Fonte"><i-lucide name="rotate-ccw" size="16"></i-lucide> Fonte
        Padrão</button>
      <button id="dark" class="accessibility-button text-nowrap"
        title="{{ modoEscuro() ? 'Modo claro' : 'Modo escuro' }}" [attr.aria-pressed]="modoEscuro()"
        (click)="alternarModoEscuro()" serigyItem="acessibilidadeAltoContraste">
        <i-lucide name="contrast" size="16"></i-lucide> {{ modoEscuro() ? 'Modo Claro' : 'Modo Escuro' }}
      </button>
    </div>
  </div>

  <a class="btn btn-lg btn-primary btn-lg-square back-to-top" id="btnTop" (click)="scrollToTop()"
    *ngIf="showBackToTopButton" matTooltip="Voltar ao topo">
    <i-lucide name="arrow-up" size="18"></i-lucide>
  </a>
</div>
